<template>
  <div>
    <!-- 
      Overlay que mostra um indicador de carregamento quando o conteúdo está sendo carregado.
      Utiliza a propriedade "isLoading" para controlar a visibilidade.
    -->
    <v-overlay :value="isLoading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <!-- 
      Renderização condicional do componente "assistenteConfiguracao". 
      Ele é exibido quando "configuracoes_component" é verdadeiro no Vuex store.
    -->
    <assistenteConfiguracao v-if="$store.state.configuracoes_component" />

    <!-- 
      Renderiza a seção do menu do usuário se "configuracoes_component" for falso no Vuex store.
      Itera sobre "menusUsuario" para exibir cada menu disponível para o usuário.
    -->
    <div class="menu_container_section_background" v-if="!$store.state.configuracoes_component">
      <div class="col-md-12 menu_container_section_container">
        <div 
          v-for="(menu, index) in menusUsuario" 
          :key="index" 
          class="menu_container_section_" 
          @click="handleClick(menu)">
          
          <!-- Mostra o badge "Novo" para menus recém-adicionados -->
          <div v-if="menu.novo == 1" class="novo-badge-item-menu">Novo</div>
          
          <!-- Exibe o ícone do menu -->
          <figure class="menu_container_section_img">
            <img :src="menu.icon" />
          </figure>

          <!-- Exibe a descrição do menu -->
          <div class="menu_container_section_text_container">
            <span class="menu_container_section_text_title">{{ menu.descricao }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * Importando os módulos necessários:
 * - axios: Para fazer requisições HTTP.
 * - assistenteConfiguracao: Componente Vue que lida com a assistência de configuração.
 * - local-storage: Módulo para acessar o localStorage no navegador.
 * - SweetAlert2: Para exibir pop-ups de alerta estilizados.
 */
import axios from '../../plugins/axios'
import assistenteConfiguracao from './configuracaoComponentes/assistenteConfiguracao.vue'
const ls = require('local-storage')
import Swal from "sweetalert2";

export default {
  components: {
    assistenteConfiguracao
  },

  data: () => ({
    menusUsuario: [],
    isLoading: false,
    config: null
  }),

  computed: {
    /**
     * @returns {number} Dias restantes para a licença do usuário.
     * Recupera esse valor do localStorage.
     */
    licencaDiasRestantes() {
      return ls.get('diasRestantes')
    },

    /**
     * @returns {number} Nível de acesso do usuário.
     * Recupera esse valor do localStorage.
     */
    nivelUsuario() {
      return ls.get('nivel_user')
    }
  },

  created() {
    this.carregarMenus();
    this.carregarConfiguracoesReports();
    this.getInfoInstituicao();
    if (this.licencaDiasRestantes <= 0) this.$router.push('licenca-expirada');
  },

  methods: {
    /**
     * Carrega os menus para o usuário com base no nível de acesso.
     * - Se os menus estiverem salvos no localStorage, eles são usados.
     * - Caso contrário, é feita uma requisição para carregar os menus do servidor.
     * @async
     */
    async carregarMenus() {
      this.isLoading = true;

      // Verifica se o nível de usuário está disponível
      if (this.nivelUsuario) {
        try {
          // Tenta carregar os menus previamente salvos no localStorage
          const rotasSaved = JSON.parse(ls.get('itemMenuHome'));

          // Se não houver menus salvos, faz a requisição no servidor e filtra pelo nível de usuário
          if (!rotasSaved) {
            const menusAll = await axios.get('/carregarMenus/1').then((res) => res.data);
            this.menusUsuario = menusAll.filter(objeto => objeto.niveis.split(',').includes(`${this.nivelUsuario}`));
            ls.set('itemMenuHome', JSON.stringify(this.menusUsuario));
          } else {
            // Carrega os menus do localStorage
            this.menusUsuario = rotasSaved;
          }
        } catch (error) {
          // Se ocorrer um erro, exibe uma mensagem de erro
          Swal.fire('Erro', 'Ocorreu um erro durante o carregamento dos menus da página!', 'error');
        } finally {
          this.isLoading = false;
        }
      } else {
        Swal.fire('Erro', 'Nível do usuário não encontrado!', 'error');
      }
    },

    /**
     * Lida com o evento de clique para cada item do menu.
     * - Se o menu não tiver uma rota, navega para a URL fornecida.
     * - Se o menu tiver uma função associada, executa essa função.
     * @param {Object} menu - O objeto menu clicado pelo usuário.
     */
    handleClick(menu) {
      if (menu.isRota === 0) {
        this.$router.push(menu.url);
      } else {
        eval(menu.funcao);
      }
    },

    /**
     * Carrega as configurações para relatórios.
     * As configurações são buscadas do servidor e armazenadas no localStorage.
     * @async
     */
    async carregarConfiguracoesReports() {
      try {
        const msg = await axios.get('/configuracoesAll').then(res => res.data);
        if (msg.length > 0) {
          ls.set('configuracoesReport', msg);
        }
      } catch (error) {
        // Loga o erro se algo der errado
        Swal.fire('Erro', 'Erro ao carregar as configurações!', 'error');
      }
    },

    async getInfoInstituicao() {
      try {
        this.config = await axios.get('/infoDetalhesInstituicao').then((res) => res.data[0]);
        ls.set('configuracaoinstituicao', this.config)
      } catch (error) {
        utilitarios.showAlertMessage('warning', 'Ocorreu um erro ao carregar as informações da instituição!');
      }
    },
  }
}
</script>

<style scoped>
.v-sheet--offset {
  top: -24px;
  position: relative;
}
</style>
